import { useCallback } from "react";
import { useClerkOrgInfo } from "./use-clerk-org-info";

export const useMemberInfo = () => {
  const members = useClerkOrgInfo();

  const getMember = useCallback(
    (userId: string) => {
      const maybeMember = members.find((m) => m?.userId === userId) || null;

      if (!maybeMember) {
        return {
          name: userId,
          firstName: userId,
          lastName: "",
          tooltip: `User ID: ${userId}`,
          member: maybeMember,
          imageUrl: undefined,
        };
      }

      return {
        name: `${maybeMember.firstName ?? ""} ${maybeMember.lastName ?? ""}`,
        firstName: maybeMember.firstName ?? userId,
        lastName: maybeMember.lastName ?? "",
        tooltip: `User ID: ${userId}`,
        member: maybeMember,
        imageUrl: maybeMember.imageUrl,
      };
    },
    [members],
  );

  return {
    members,
    getMember,
  };
};
